<template>
  <div class="footer-view">
    <div class="footer-top">
      <div class="top1">
        相关链接
      </div>
      <div class="top2">
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <a :href="item.url" target="_blank">
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-b">
      <div class="div1">
        <div class="div2"></div>
        <div class="div3">
          <img style="width:100px;height:100px" :src="img2" alt="">
          <p>微信端</p>
        </div>
        <div class="div2"></div>
      </div>
      <p>Copyright2015 言实出版社 版权所有 <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025314">京公网安备号：11010802025314</a> | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备 15050842 号-2</a></p>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      img1: require('@/assets/foot_wx1.gif'),
      img2: require('@/assets/foot_wx2.gif'),
      list: [{
        url: 'http://www.zgzcinfo.cn/',
        text: '中国政策研究网'
      }, {
        url: 'http://www.zgzcexpert.cn/',
        text: '中国政策专家库'
      }, {
        url: 'http://www.zgyscbs.cn/',
        text: '中国言实出版社'
      }, {
        url: 'http://www.ccdi.gov.cn/',
        text: '中央纪委'
      }, {
        url: 'http://www.zgg.org.cn/',
        text: '紫光阁'
      }, {
        url: 'http://www.scio.gov.cn/index.htm',
        text: '新闻办'
      }, {
        url: 'http://www.people.com.cn/',
        text: '人民网'
      }, {
        url: 'http://www.china.com.cn/',
        text: '中国网'
      }, {
        url: 'http://www.cctv.com/',
        text: 'CNTV'
      }, {
        url: 'http://www.chinadaily.com.cn/',
        text: '中国日报'
      }, {
        url: 'http://www.youth.cn/',
        text: '中青网'
      }, {
        url: 'http://www.ce.cn/',
        text: '中经网'
      }, {
        url: 'http://www.taiwan.cn/',
        text: '中国台湾'
      }, {
        url: 'http://www.cnr.cn/',
        text: '央广网'
      }, {
        url: 'http://www.gmw.cn/',
        text: '光明网'
      }, {
        url: 'http://www.chinanews.com/',
        text: '中新网'
      }, {
        url: 'http://www.sodexhoau.com/',
        text: '亚洲网'
      }, {
        url: 'http://www.dangjian.cn/',
        text: '党建网'
      }, {
        url: 'http://www.k618.cn/',
        text: '未来网'
      }, {
        url: 'http://www.ccn.com.cn/',
        text: '中国消费网'
      }, {
        url: 'http://www.daja.net.cn/',
        text: '全国打假网'
      }]
    }
  }
}
</script>
<style lang="less" scoped>
a{
  text-decoration: none;
}
  .footer-view{
    .footer-top{
      height: 100px;
      padding-top: 50px;
      background-color: #e5e8e8;
      color: #004D8B;
      font-weight: bold;
      display: flex;
      .top1{
        width: 100px;
        line-height: 70px;
        text-align: center;
      }
      .top2{
        flex: 1;
        ul{
          list-style: none;
          li{
            display: inline-block;
            padding: 0 10px;
            a{
              text-decoration: none;
              color: #004D8B;
            }
          }
        }
      }
    }
    .footer-b{
      background-color: #e5e8e8;
      padding: 30px 0;
      .div1{
        text-align: center;
        display: flex;
        .div2{
          flex: 1;
        }
        .div3{
          padding: 0 10px;
        }
        p{
          padding: 0;
          margin: 0;
          font-size: 14px;
        }
      }
      p{
        text-align: center;
        padding: 0;
        margin: 0;
        margin-top: 20px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/footer/footer.vue